import unoformBase from './unoform'

export default {
  ...unoformBase,
}
